module.exports = __webpack_public_path__ + "static/img/pro9_tab6.0773a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab6.jpg
// module id = E1wE
// module chunks = 171